import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Modal, Form, Table, InputGroup, Card } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import './campaigncss/Enrollement.css'
import useTranslations from '../transalation/TranslationUtils';
import { useSelector } from 'react-redux';
import { useRef } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getCampaignsByPage, searchCampaignsByPage } from 'app/redux/slices/rdxCampaignSlice';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Close, Delete, NavigateNext } from '@mui/icons-material';
import { DEFAULT_IP } from "app/utils/constant";

function Enrollment({ }) {
    const { cancel, save, pushstatus, assignTo, cancelled, mobile, func_t, quota, memberid, membername, role_edit, usersearch, enrolmentStatus, campaignname,
        noOfApplications,
        quotaUsage,
        approver,
        lastUpdate,
        addMember,
        editMember,
        memberNotFound,
        approver2,
        addGroup,
        preApprove,
        approve,
        waitlist,
        campaignName,
        code,
        type,
        i18nObj,
        startDate,
        pic,
        pushreset,
        cmpgnStatusDraft,
        cmpgnStatusPromotion,
        cmpgnStatusEnrolment,
        cmpgnStatusInProgress,
        cmpgnStatusSurvey,
        showSuccessMsg,
        showErrMsg,
        loadMore,
        noOfApproval,
        withdraw,
        identity } = useTranslations();

    const identityShortCodeMap = {
        'Adult': 'ADU',
        'Appointed Caregiver': 'EEC',
        'Caregiver': 'CAG',
        'Instructor': 'INS',
        'Pre-Senior': 'ECV',
        'Senior': 'ECM',
        'Volunteer': 'EVW'
    };

    const getIdentityShortCodes = (identities) => {
        if (!identities) return '-';
        
        if (Array.isArray(identities)) {
            return identities
                .map(identity => identityShortCodeMap[identity] || identity)
                .join(', ');
        }
        
        return identityShortCodeMap[identities] || identities;
    };

    const calculateIdentityCounts = (enrollmentData) => {
        const counts = { EEC: 0, ECV: 0, ECM: 0, EVW: 0 };
        
        enrollmentData.forEach(enroll => {
            // Only count registered members (enroll_status === 1)
            if (enroll.enroll_status === 1 && enroll.identities) {
                let identities;
                
                // Handle different data formats
                if (Array.isArray(enroll.identities)) {
                    identities = enroll.identities;
                } else if (typeof enroll.identities === 'string') {
                    // Split comma-separated string
                    identities = enroll.identities.split(',').map(id => id.trim());
                } else {
                    identities = [enroll.identities];
                }
                
                identities.forEach(identity => {
                    // Check if it's already a short code
                    if (counts.hasOwnProperty(identity)) {
                        counts[identity]++;
                    } else {
                        // Try to map from full name to short code
                        const shortCode = identityShortCodeMap[identity];
                        if (shortCode && counts.hasOwnProperty(shortCode)) {
                            counts[shortCode]++;
                        }
                    }
                });
            }
        });
        
        return counts;
    };

    const dispatch = useDispatch();
    const memberIdRef = useRef(null);
    const campaignDetails = useSelector((state) => state.rdxCampaign?.campaignEditData || {});
    const users = useSelector((state) => state.rdxMain?.adminList || {});
    const campaignTypeList = useSelector((state) => state.rdxMain?.campaignTypeList || []);
    const [selectCampaign, setSelectCamapign] = useState({});
    const [page, setPage] = useState(0);
    const [hasLoadMore, setHasLoadMore] = useState(false);
    const [campaignList, setCampaignList] = useState([]);
    const [showMemberModal, setShowMemberModal] = useState(false);
    const [showGroupModal, setShowGroupModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [searchParams, setSearchParams] = useState({
        campaignName: "",
        code: "",
        type: "",
        status: "",
        startDate: "",
        pic: "",
        sis: ""
    });

    const [prevParams, setPrevParams] = useState({
        campaignName: "",
        code: "",
        type: "",
        status: "",
        startDate: "",
        pic: "",
        sis: ""
    });

    const [enrollmentList, setEnrollmentList] = useState([]);
    const [enrollmentQuotas, setEnrollmentQuotas] = useState({
        "campaign_quota": -1,
        "no_application": -1,
        "usage": -1
    });
    const [importEnrolList, setImportEnrolList] = useState([]);
    const [importEnrolQuota, setImportEnrolQuota] = useState({
        "campaign_quota": -1,
        "no_application": -1,
        "usage": -1
    });
    const [memberId, setMemberId] = useState("");
    const [newMember, setNewMember] = useState({
        account_id: "",
        account_name: "",
        account_phone: "",
        status: -1,
    });
    const [focusMap, setFocusMap] = useState({
        member_id: false,
        account_name: false,
        account_phone: false,
    });
    const [accountId, setAccountId] = useState(""); // Add state for account_id


    useEffect(() => {
        if (searchParams) {
            if (searchParams.campaignName != prevParams.campaignName ||
                searchParams.code != prevParams.code ||
                searchParams.type != prevParams.type ||
                searchParams.status != prevParams.status ||
                searchParams.startDate != prevParams.startDate ||
                searchParams.pic != prevParams.pic ||
                searchParams.sis != prevParams.sis) {
                setHasLoadMore(false);
            } else if (!searchParams.campaignName &&
                !searchParams.code &&
                !searchParams.type &&
                !searchParams.status &&
                !searchParams.startDate &&
                !searchParams.pic &&
                !searchParams.sis) {
                //reset search and page init search here
                resetSelectCampaign();
                handleSearch(false);
            }
        }
    }, [searchParams]);

    const handleCampainSearchChange = (e) => {
        const { name, value } = e.target;
        if (name === "code") {
            // Ensure code is numeric and max 6 digits
            if (/^\d{0,6}$/.test(value)) {
                setSearchParams((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        } else {
            setSearchParams((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSearch = (hasNext) => {
        let isSearchMode = true;
        if (!searchParams.campaignName &&
            !searchParams.code &&
            !searchParams.type &&
            !searchParams.status &&
            !searchParams.startDate &&
            !searchParams.pic &&
            !searchParams.sis) {
            isSearchMode = false;
        }

        let mPage = 1;
        if (!hasNext) {
            setPrevParams(searchParams);
            setPage(mPage);
        } else {
            mPage = page + 1;
            setPage(mPage);
        }

        let callback = (isSuccess, data) => {
            if (isSuccess) {
                if (mPage > 1) {
                    console.log("more");
                    if (!data.data?.data || data.data?.data.length == 0) {
                        setHasLoadMore(false);
                    } else {
                        setHasLoadMore(true);
                        const newList = [...campaignList];
                        data.data?.data.forEach((item) => {
                            newList.push(item);
                        })
                        setCampaignList(newList);
                    }
                } else {
                    console.log("first");
                    if (!data.data?.data || data.data?.data.length == 0) {
                        setHasLoadMore(false);
                    } else {
                        setHasLoadMore(true);
                    }
                    resetSelectCampaign();
                    setCampaignList(data.data?.data);
                }
            } else {
                let revertPage = mPage - 1;
                if (revertPage < 1) {
                    revertPage = 1;
                }
                setPage(revertPage);
                alert(showErrMsg(data));
            }
        }

        if (isSearchMode) {
            let sendData = {};
            if (searchParams.campaignName) {
                sendData["campaign_name"] = searchParams.campaignName;
            }
            if (searchParams.code) {
                sendData["campaign_code"] = searchParams.code;
            }
            if (searchParams.type) {
                sendData["campaign_type_id"] = searchParams.type;
            }
            if (searchParams.status && "-1" != searchParams.status) {
                sendData["campaign_status"] = parseInt(searchParams.status);
            }
            if (searchParams.sis) {
                sendData["sis"] = searchParams.sis;
            }
            if (searchParams.startDate) {
                sendData["start_date"] = searchParams.startDate;
            }
            if (searchParams.pic) {
                sendData["admin_id"] = searchParams.pic;
            }
            dispatch(searchCampaignsByPage(mPage, sendData, callback));
        } else {
            dispatch(getCampaignsByPage(mPage, callback));
        }
    };

    const onCampaignClick = (item) => {
        setSelectCamapign(item);
        getImportEnrollmentList(item.campaign_id);
    }

    const resetSelectCampaign = () => {
        setImportEnrolList([]);
        setImportEnrolQuota({
            "campaign_quota": -1,
            "no_application": -1,
            "usage": -1
        });
        setSelectCamapign({});
    }

    const handleReset = () => {
        setSearchParams({
            campaignName: "",
            code: "",
            type: "",
            status: "",
            startDate: "",
            pic: "",
            sis: ""
        });

        setPrevParams({
            campaignName: "",
            code: "",
            type: "",
            status: "",
            startDate: "",
            pic: "",
            sis: ""
        });

        //trigger reset search in searchParams's useEffect
    };

    const onImportEnrolmentsClick = async (item) => {
        let acctIds = [];
        importEnrolList.forEach((item) => {
            acctIds.push(item.account_id);
        });

        let sendData = {
            campaign_id: selectCampaign.campaign_id,
            attendee_list: acctIds
        }

        const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/importattendee2campaign", sendData);
        let data = postRes.data;

        if (1 == data?.code) {
            alert(showSuccessMsg(data));
            handleCloseGroupModal();
            handleReset();
            fetchEnrollmentList();
        } else {
            alert(showErrMsg(data));
        }
    }

    // Show modals for adding or editing
    const handleShowMemberModal = () => setShowMemberModal(true);
    const handleCloseMemberModal = () => {
        setShowMemberModal(false);
        setIsEditing(false);
        setNewMember({
            account_id: "",
            account_name: "",
            account_phone: "",
            status: -1,
        });
    };

    const handleShowGroupModal = () => setShowGroupModal(true);
    const handleCloseGroupModal = () => setShowGroupModal(false);




    const handleEditMember = (index) => {
        const member = enrollmentList[index];
        setNewMember({
            account_id: (member.account_id) ? (member.account_id) : "",
            account_name: (member.account_name) ? (member.account_name) : "",
            account_phone: (member.account_phone) ? (member.account_phone) : "",
            status: (member.enroll_status) ? (member.enroll_status) : -1,
        });
        setMemberId(member.member_id);
        setAccountId(member.account_id); // Set account_id
        setIsEditing(true);
        handleShowMemberModal();
    };

    const handleUpdateMember = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(DEFAULT_IP + `/webapp/memportal/updateenrollmentstatus`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Token: token,
                },
                body: JSON.stringify({
                    campaign_id: campaignDetails.campaign_id,
                    account_id: accountId, // Use account_id
                    enroll_status: newMember.status,
                }),
            });

            const data = await response.json();
            if (data.code === 1) {
                alert("Member updated successfully!");
                handleCloseMemberModal();
                fetchEnrollmentList(); // Refresh the list
            } else {
                alert(data.message_en || "Failed to update member.");
            }
        } catch (error) {
            console.error("Error updating member:", error);
            alert("System problem");
        }
    };

    const getImportEnrollmentList = async (campaignId) => {
        const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/getcampaignenrollmentlist", {
            campaign_id: campaignId
        });
        let data = postRes.data;

        if (1 == data?.code) {
            setImportEnrolList(data.data?.enroll_list || []);
            if (data.data?.quata_data) {
                setImportEnrolQuota(data.data?.quata_data);
            }
        } else {
            alert(showErrMsg(data));
        }
    };

    const fetchEnrollmentList = async () => {
        const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/getcampaignenrollmentlist", {
            campaign_id: campaignDetails.campaign_id
        });
        let data = postRes.data;

        if (1 == data?.code) {
            setEnrollmentList(data.data?.enroll_list || []);
            if (data.data?.quata_data) {
                setEnrollmentQuotas(data.data?.quata_data);
            }
        } else {
            alert(showErrMsg(data));
        }
    };

    // Fetch data on component mount
    useEffect(() => {
        if (campaignDetails?.campaign_id) {
            fetchEnrollmentList();
        }
    }, [])

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "account_phone" && !/^\d{0,10}$/.test(value)) return; // Allow only up to 8 digits

        if ("status" == name) {
            setNewMember((prev) => ({
                ...prev,
                "status": parseInt(value),
            }));
        } else {
            setNewMember((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleFocusChange = (name, val) => {
        let dft = {
            member_id: false,
            account_name: false,
            account_phone: false,
        };
        setFocusMap((prev) => ({
            ...prev,
            ...dft,
            [name]: val,
        }));
    };

    const handleMemberIdChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,8}$/.test(value)) { // Allow only up to 8 digits
            setMemberId(value);
        }
    };


    const handleSearchMember = async (key, val) => {
        try {

            let sendData = {};
            sendData[key] = val;
            let res = await axios.post(DEFAULT_IP + "/webapp/memportal/searchmemberv2?page=1", sendData);
            let list = res.data?.data?.data;

            if (Array.isArray(list) && list && list.length > 0) {
                let accountId = (list[0].account_id) ? (list[0].account_id) : "";
                let memberId = (list[0].member_id) ? (list[0].member_id) : "";
                let accountName = (list[0].account_name) ? (list[0].account_name) : "";
                let accountPhone = (list[0].account_phone) ? (list[0].account_phone) : "";

                setMemberId(memberId);
                setNewMember((prev) => ({
                    ...prev,
                    account_id: accountId,
                    account_name: accountName,
                    account_phone: accountPhone
                }));
            } else {
                alert(memberNotFound());
                if (key != "member_id") {
                    setMemberId("");
                }

                setNewMember((prev) => ({
                    ...prev,
                    account_id: "",
                    account_name: "",
                    account_phone: "",
                    [key]: val
                }));
            }
        } catch (error) {
            console.error("Error fetching member details:", error);
        }
    };



    const handleSaveMember = async () => {
        try {
            const token = localStorage.getItem("authToken");

            // Ensure account_id is available
            if (!newMember.account_id) {
                alert("Account ID is missing. Please search for the member first.");
                return;
            }

            const response = await fetch(DEFAULT_IP + `/webapp/memportal/addmembertocampaign`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Token: token, // Replace with actual token
                },
                body: JSON.stringify({
                    campaign_id: campaignDetails.campaign_id,
                    account_id: newMember.account_id, // Use the account_id from state
                    account_name: newMember.account_name,
                    account_phone: newMember.account_phone,
                    enroll_status: newMember.status
                }),
            });

            const data = await response.json();
            console.log(data); // Log the response data to see what's returned
            if (data.code === 1) {
                alert("Member saved successfully!");
                handleCloseMemberModal();
                fetchEnrollmentList();
            } else {
                alert(data.message_en || "Failed to save member.");
            }
        } catch (error) {
            console.error("Error saving member:", error);
        }
    };

    return (
        <Container>
            <Row>
                <Card className="mt-0 border-0" style={{ position: 'relative' }}>
                    <Card.Body style={{ padding: 0, paddingTop: '16px' }}>
                        <div className="d-flex justify-content-between align-items-center my-class">
                            <h5 className='enrollementhead'>{enrolmentStatus()}</h5>
                            <div className="d-flex me-">
                                <Button
                                    variant="success"
                                    className="custom-success-btn me-2"
                                    style={{ width: '160px' }}
                                    disabled={!campaignDetails.is_publish }
                                    onClick={() => {
                                        handleShowMemberModal();
                                        setTimeout(() => {
                                            setMemberId("");
                                            setNewMember({
                                                account_id: "",
                                                account_name: "",
                                                account_phone: "",
                                                status: -1
                                            });

                                            if (memberIdRef && memberIdRef.current) {
                                                memberIdRef.current.focus();
                                            }

                                            setFocusMap((prev) => ({
                                                ...prev,
                                                "member_id": true,
                                            }));
                                        });
                                    }}
                                >
                                    {addMember()}
                                </Button>
                                <Button
                                    variant="success"
                                    className="custom-success-btn ms-auto"
                                    style={{ width: '160px' }}
                                    disabled={!campaignDetails.is_publish }
                                    onClick={handleShowGroupModal}
                                >
                                    {addGroup()}
                                </Button>
                            </div>
                        </div>


                        {enrollmentQuotas.usage < 0 &&
                            <Row>
                                <Col xs={12} className="d-flex mt-5 ms-2 flex-wrap">
                                    <p className='grouplabel me-5'>{quota()}: ---</p>
                                    <p className='grouplabel me-5'>{noOfApplications()}: ---</p>
                                    <p className='grouplabel me-5'>{noOfApproval()}: ---</p>
                                    <p className='grouplabel me-5'>{quotaUsage()}: ---%</p>
                                    {(() => {
                                        const identityCounts = calculateIdentityCounts(enrollmentList);
                                        console.log("identityCounts.EEC: "+identityCounts.EEC)
                                        return (
                                            <>
                                                <p className='grouplabel me-5'>EEC: {identityCounts.EEC}</p>
                                                <p className='grouplabel me-5'>ECV: {identityCounts.ECV}</p>
                                                <p className='grouplabel me-5'>ECM: {identityCounts.ECM}</p>
                                                <p className='grouplabel me-5'>EVW: {identityCounts.EVW}</p>
                                            </>
                                        );
                                    })()}
                                </Col>
                            </Row>
                        }

                        {enrollmentQuotas.usage >= 0 &&
                            <Row>
                                <Col sm={12} className="d-flex mt-5 ms-2 flex-wrap">
                                    <p className='grouplabel me-5'>{quota()}: {enrollmentQuotas.campaign_quota}</p>
                                    <p className='grouplabel me-5'>{noOfApplications()}: {enrollmentQuotas.no_application}</p>
                                    <p className='grouplabel me-5'>{noOfApproval()}: {enrollmentQuotas.no_approval}</p>
                                    <p className='grouplabel me-5' style={enrollmentQuotas.usage > 100 ? { color: 'red' } : {}}
                                    >{quotaUsage()}: {enrollmentQuotas.usage}%</p>
                                    {(() => {
                                        const identityCounts = calculateIdentityCounts(enrollmentList);
                                        return (
                                            <>
                                                <p className='grouplabel me-5'>EEC: {identityCounts.EEC}</p>
                                                <p className='grouplabel me-5'>ECV: {identityCounts.ECV}</p>
                                                <p className='grouplabel me-5'>ECM: {identityCounts.ECM}</p>
                                                <p className='grouplabel me-5'>EVW: {identityCounts.EVW}</p>
                                            </>
                                        );
                                    })()}
                                </Col>
                            </Row>
                        }

                        <Table striped hover responsive>
                            <thead className="text-center">
                                <tr>
                                    <th className="tableheadgrp">
                                        <div className="button-group d-flex ">
                                            {memberid()}
                                        </div>
                                    </th>
                                    <th className="tableheadgrp">
                                        <div className="button-group d-flex ">
                                            {membername()}
                                        </div></th>
                                    <th className="tableheadgrp">   <div className="button-group d-flex ">
                                        {mobile()}
                                    </div></th>
                                    <th className="tableheadgrp">   <div className="button-group d-flex ">
                                        {approver()}
                                    </div></th>
                                    <th className="tableheadgrp">   <div className="button-group d-flex ">
                                        {pushstatus()}
                                    </div></th>
                                    <th className="tableheadgrp">   <div className="button-group d-flex justify-content-start align-items-start">
                                        {lastUpdate()}
                                    </div></th>
                                    <th className="tableheadgrp">   <div className="button-group d-flex justify-content-start align-items-start">
                                        {identity()}
                                    </div></th>
                                    <th className="tableheadgrp">   <div className="button-group d-flex justify-content-end align-items-end">
                                        {func_t()}
                                    </div></th>
                                </tr>
                            </thead>
                            <tbody className="tableheadgrp text-start">
                                {enrollmentList.length > 0 ? (
                                    enrollmentList.map((enroll, index) => (
                                        <tr key={index}>
                                            <td>{enroll.member_id}</td>
                                            <td>{enroll.account_name}</td>
                                            <td>{enroll.account_phone}</td>
                                            <td>{enroll.approver_name}</td>
                                            <td>
                                                {1 === enroll.enroll_status && (approver2())}
                                                {3 === enroll.enroll_status && (waitlist())}
                                                {5 === enroll.enroll_status && (cancelled())}
                                            </td>
                                            <td>
                                                {new Date(enroll.update_date).toLocaleDateString()}{" "}
                                                {new Date(enroll.update_date).toLocaleTimeString()}
                                            </td>
                                            <td>
                                                {getIdentityShortCodes(enroll.identities)}
                                            </td>
                                            <td>
                                                <div className="button-group d-flex justify-content-end align-items-end">
                                                    <Button variant="primary" className="useraddbtn" onClick={() => handleEditMember(index)}>
                                                        {role_edit()}
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            No enrollments found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                    </Card.Body>
                </Card>
            </Row>


            <Modal show={showMemberModal} onHide={handleCloseMemberModal} centered className="custom-modal-width">
                <Modal.Body>
                    <Form>
                        <h4 className="memberheads ms-2">{isEditing ? editMember() : addMember()}</h4>

                        {/* Member ID */}
                        <Row className="mb-3 ms-2">
                            <Col md={8}>
                                <Form.Group controlId="memberId">
                                    <Form.Label className="grouplabel">{memberid()}</Form.Label>
                                    <Form.Control
                                        ref={memberIdRef}
                                        type="text"
                                        value={memberId}
                                        name="member_id"
                                        onChange={handleMemberIdChange}
                                        className="memberslabels"
                                        disabled={isEditing}
                                        onFocus={() => setTimeout(() => handleFocusChange("member_id", true))}

                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className="d-flex align-items-end justify-content-end">
                                {(!isEditing && focusMap["member_id"]) && (
                                    <Button variant="primary" onClick={() => { handleSearchMember("member_id", memberId); }}
                                        className="useraddbtn">
                                        {usersearch()}
                                    </Button>
                                )}
                            </Col>
                        </Row>

                        {/* Member Name */}
                        <Row className="mb-3 ms-2">
                            <Col md={8}>
                                <Form.Group controlId="accountName">
                                    <Form.Label className="grouplabel">{membername()}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newMember.account_name}
                                        name="account_name"
                                        onChange={handleInputChange}
                                        className="memberslabels"
                                        disabled={isEditing}
                                        onFocus={() => setTimeout(() => handleFocusChange("account_name", true))}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className="d-flex align-items-end justify-content-end">
                                {(!isEditing && focusMap["account_name"]) && (
                                    <Button variant="primary" onClick={() => { handleSearchMember("account_name", newMember.account_name); }}
                                        className="useraddbtn">
                                        {usersearch()}
                                    </Button>
                                )}
                            </Col>
                        </Row>

                        {/* Mobile */}
                        <Row className="mb-3 ms-2">
                            <Col md={8}>
                                <Form.Group controlId="accountPhone">
                                    <Form.Label className="grouplabel">{mobile()}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newMember.account_phone}
                                        name="account_phone"
                                        onChange={handleInputChange}
                                        className="memberslabels"
                                        disabled={isEditing}
                                        onFocus={() => setTimeout(() => handleFocusChange("account_phone", true))}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4} className="d-flex align-items-end justify-content-end">
                                {(!isEditing && focusMap["account_phone"]) && (
                                    <Button variant="primary" onClick={() => { handleSearchMember("account_phone", newMember.account_phone); }}
                                        className="useraddbtn">
                                        {usersearch()}
                                    </Button>
                                )}
                            </Col>
                        </Row>

                        {/* Status */}
                        <Form.Group controlId="formStatus" className="mt-3 ms-3">
                            <Form.Label className="grouplabel">{pushstatus()}</Form.Label>
                            <div className="d-flex flex-wrap">
                                <Form.Check
                                    type="radio"
                                    label={approver2()}
                                    name="status"
                                    value={1}
                                    checked={newMember.status === 1}
                                    onChange={handleInputChange}
                                    className="grouplabel me-3"
                                />
                                <Form.Check
                                    type="radio"
                                    label={waitlist()}
                                    name="status"
                                    value={3}
                                    checked={newMember.status === 3}
                                    onChange={handleInputChange}
                                    className="grouplabel me-3"
                                />
                                <Form.Check
                                    type="radio"
                                    label={cancelled()}
                                    name="status"
                                    value={5}
                                    checked={newMember.status === 5}
                                    onChange={handleInputChange}
                                    className="grouplabel me-3"
                                />
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>


                    <Col md={4} className="d-flex align-items-end justify-content-end">
                        <Button variant="" onClick={handleCloseMemberModal} className=" me-2 canslebtndialog">
                            {cancel()}
                        </Button>
                        <Button variant="" onClick={isEditing ? handleUpdateMember : handleSaveMember} className="logoutdialogbtn">
                            {save()}
                        </Button>
                    </Col>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showGroupModal}
                onHide={handleCloseGroupModal}
                centered
                className="custom-modal-group"
            >
                <Modal.Body>
                    <h4 className='groupheading ps-3'>Add a Group</h4>

                    {/* Filter Section */}
                    <Card className="p-3 mb-3 border-0">
                        <Form>
                            <Row className="g-3"> {/* Added spacing between elements */}
                                <Col md={3} className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{campaignName()}:</Form.Label>
                                    <Form.Control type="text" name="campaignName" value={searchParams.campaignName} onChange={handleCampainSearchChange} />
                                </Col>
                                <Col md={2} className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{code()}:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="code"
                                        value={searchParams.code}
                                        onChange={handleCampainSearchChange}
                                    />
                                </Col>
                                <Col md={2} className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{type()}:</Form.Label>
                                    <Form.Select name="type" value={searchParams.type} onChange={handleCampainSearchChange}>
                                        <option value=""></option>
                                        {campaignTypeList.map((item) => (
                                            <option key={item.campaign_type_code} value={item.campaign_type_code}>
                                                {item.campaign_type_code} ({i18nObj(item.campaign_type_name)})
                                            </option>))}
                                    </Form.Select>

                                </Col>
                                <Col md={2} className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{pushstatus()}:</Form.Label>
                                    <Form.Select name="status" value={searchParams.status} onChange={handleCampainSearchChange}>
                                        <option value=""></option>
                                        <option value="0">{cmpgnStatusDraft()}</option>
                                        {/* <option>Pending Approval</option>
                                      <option>Approved</option> */}
                                        <option value="4">{cmpgnStatusPromotion()}</option>
                                        {/* <option>Pre-registration</option> */}
                                        <option value="5">{cmpgnStatusEnrolment()}</option>
                                        {/* <option>Start</option>
                                      <option>End</option> */}
                                        <option value="6">{cmpgnStatusInProgress()}</option>
                                        <option value="7">{cmpgnStatusSurvey()}</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3} className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{startDate()}:</Form.Label>
                                    <Form.Control type="date" name="startDate" value={searchParams.startDate} onChange={handleCampainSearchChange} />
                                </Col>

                                <Col md={3} className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>{pic()}:</Form.Label>

                                    <Form.Select name="pic" value={searchParams.pic} onChange={handleCampainSearchChange}>
                                        <option value=""></option>

                                        {users.map((item) => (
                                            <option key={item.admin_id} value={item.admin_name}>
                                                {typeof item.admin_name === 'string' ? item.admin_name : item.admin_name?.zh || item.admin_name?.en || 'Unknown'}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>


                                <Col md={2} className="d-flex align-items-center">
                                    <Form.Label className="me-2 mb-0 notificationinputname" style={{ whiteSpace: 'nowrap' }}>SIS : </Form.Label>
                                    <Form.Select name="sis" value={searchParams.sis} onChange={handleCampainSearchChange}>
                                        <option value=""></option>
                                        <option>Y</option>
                                        <option>N</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col className="d-flex align-items-center">
                                    <Button variant="success" className="custom-success-btn me-2" onClick={() => handleSearch(false)}>{usersearch()}</Button>
                                    <Button variant="success" className="custom-success-btn me-2" onClick={handleReset}>{pushreset()}</Button>
                                </Col>
                            </Row>
                        </Form>

                        <Row className="mt-2">
                            <Col>
                                {!selectCampaign.campaign_id && (
                                    <React.Fragment>
                                        {campaignList.map((item, index) => (
                                            <Button className="m-1" key={index} variant="outline-primary"
                                                onClick={() => onCampaignClick(item)}
                                            >{i18nObj(item.campaign_name)}</Button>
                                        ))}
                                        {hasLoadMore && (
                                            <Link className="ms-2" component="button" variant="body2" onClick={() => handleSearch(true)}
                                            >{loadMore()}
                                            </Link>
                                        )}
                                    </React.Fragment>
                                )}
                                {selectCampaign.campaign_id && (
                                    <React.Fragment>
                                        <Button className="m-1" variant="primary"
                                        >{i18nObj(selectCampaign.campaign_name)}</Button>
                                        <Close style={{ "cursor": "pointer" }}
                                            onClick={() => resetSelectCampaign()}></Close>
                                    </React.Fragment>
                                )}
                            </Col>
                        </Row>

                        {selectCampaign.campaign_id && (
                            <Row className="mt-5">
                                <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNext fontSize="small" />}>
                                    <Typography variant="h5" color="text.primary">{i18nObj(selectCampaign.campaign_name)}</Typography>
                                    <Typography variant="h5" color="text.primary">Import Enrolment List</Typography>
                                </Breadcrumbs>

                                {importEnrolQuota.usage < 0 &&
                                    <Col xs={12} className="d-flex mt-3 flex-wrap">
                                        <p className='grouplabel me-5'>{quota()}: ---</p>
                                        <p className='grouplabel me-5'>{noOfApplications()}: ---</p>
                                        <p className='grouplabel me-5'>{noOfApproval()}: ---</p>
                                        <p className='grouplabel me-5'>{quotaUsage()}: ---%</p>
                                    </Col>
                                }

                                {importEnrolQuota.usage >= 0 &&
                                    <Col xs={12} className="d-flex mt-3 flex-wrap">
                                        <p className='grouplabel me-5'>{quota()}: {importEnrolQuota.campaign_quota}</p>
                                        <p className='grouplabel me-5'>{noOfApplications()}: {importEnrolQuota.no_application}</p>
                                        <p className='grouplabel me-5'>{noOfApproval()}: {importEnrolQuota.no_approval}</p>
                                        <p className='grouplabel me-5' style={importEnrolQuota.usage > 100 ? { color: 'red' } : {}}
                                        >{quotaUsage()}: {importEnrolQuota.usage}%</p>
                                    </Col>
                                }

                                <Col xs={12}>
                                    <Table striped hover responsive>
                                        <thead>
                                            <tr>
                                                <th className='tableheadgrp'>{memberid()}</th>
                                                <th className='tableheadgrp'>{membername()}</th>
                                                <th className='tableheadgrp'>{mobile()}</th>
                                                <th className='tableheadgrp'>{pushstatus()}</th>
                                                <th className='tableheadgrp'>{lastUpdate()}</th>
                                                <th className='tableheadgrp'>{identity()}</th>
                                                <th className='tableheadgrp'>{func_t()}</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tableheadgrp'>
                                            {importEnrolList.length > 0 ? (
                                                importEnrolList.map((enroll, index) => (
                                                    <tr key={index}>
                                                        <td>{enroll.member_id}</td>
                                                        <td>{enroll.account_name}</td>
                                                        <td>{enroll.account_phone}</td>
                                                        <td>
                                                            {1 == enroll.enroll_status && (approver2())}
                                                            {3 == enroll.enroll_status && (waitlist())}
                                                            {5 == enroll.enroll_status && (cancelled())}
                                                        </td>
                                                        <td>
                                                            {new Date(enroll.update_date).toLocaleDateString()}{" "}
                                                            {new Date(enroll.update_date).toLocaleTimeString()}
                                                        </td>
                                                        <td>
                                                            {getIdentityShortCodes(enroll.identities)}
                                                        </td>
                                                        <td>
                                                            <div className="button-group d-flex justify-content-start">
                                                                <Button variant="danger" onClick={() => {
                                                                    setImportEnrolList((prevList) => prevList.filter((item, innerIndex) => index !== innerIndex));
                                                                }}>{<Delete />}</Button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        No enrollments found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        )}

                    </Card>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="" className='groupclear'
                        onClick={() => {
                            handleCloseGroupModal();
                            handleReset();
                        }}>{cancel()}
                    </Button>
                    <Button variant="" className='groupsearch' onClick={onImportEnrolmentsClick} >Import</Button>
                </Modal.Footer>
            </Modal>



        </Container>
    );
}

export default Enrollment;